import messages from '../locales/messages';
import './TurbonomicPriceEstimator.scss';
import 'src/common/style/common.scss';
import {
  cookieContentObject,
  roiCookieContent,
} from './TurbonomicPriceEstimator';
import { ReactElement, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { ThanksModal, thanksTable } from 'src/common/utils/ThanksModal';
export interface thanksProps {
  interestedInContainers: string;
  cloudInstances: number;
  onPremVMs: number;
  productToAcquire: string;
  estimatedPrice: string;
  cookieContent: roiCookieContent;
  bpName: string;
  bpConsentMail: boolean;
}

const Thanks = ({
  interestedInContainers,
  cloudInstances,
  onPremVMs,
  productToAcquire,
  estimatedPrice,
  cookieContent,
}: thanksProps): ReactElement => {
  const intl = useIntl();
  let contentThanks2: thanksTable[] = [];
  const [showThanksModal, setShowThanksModal] = useState(true);
  const [ROIShow, setROIShow] = useState(false);
  useEffect(() => {
    if (
      Object.keys(cookieContent).length !== 0 &&
      cookieContent.estimate.length !== 0
    ) {
      setROIShow(true);
    }
  }, [cookieContent]);
  const titleThanks: thanksTable[] = [
    {
      group: 'title',
      value: String(intl.formatMessage(messages['thankYouTitle'])),
    },
    {
      group: 'subTitle',
      value: String(intl.formatMessage(messages['thankYouSubTitle'])),
    },
  ];
  const widgetTitleThanks: thanksTable[] = [
    {
      group: 'widgetTitle1',
      value: 'Price Estimator',
    },
  ];
  ROIShow &&
    widgetTitleThanks.push({
      group: 'widgetTitle2',
      value: 'ROI',
    });
  const contentThanks: thanksTable[] = [
    {
      group: String(intl.formatMessage(messages['totalOnPremVvmsTitle'])),
      value: String(onPremVMs),
    },
    {
      group: String(intl.formatMessage(messages['totalCloudInstancesTitle'])),
      value: String(cloudInstances),
    },
    {
      group: String(
        intl.formatMessage(messages['interestedInContainersTilte']),
      ),
      value: String(interestedInContainers),
    },
    {
      group: String(
        intl.formatMessage(messages['productToAcquireHeadTooltip']),
      ),
      value: String(productToAcquire),
    },
    {
      group: String(intl.formatMessage(messages['estimatedCosts'])),
      value: String(estimatedPrice),
    },
  ];
  {
    ROIShow
      ? (contentThanks2 = [
          {
            group: String(
              intl.formatMessage(
                messages['totalCurrentNumberOnPremHostsTitle'],
              ),
            ),
            value: String(cookieContent.currentNumberOnPremHosts),
          },
          {
            group: String(
              intl.formatMessage(
                messages['totalCurrentMonthtlyCloudBillTitle'],
              ),
            ),
            value: String(cookieContent.currentMonthtlyCloudBill),
          },
          {
            group: String(
              intl.formatMessage(messages['TotalCurrentCostOnPremHostTilte']),
            ),
            value: String(cookieContent.currentCostOnPremHost),
          },
          {
            group: String(
              intl.formatMessage(messages['annualGrowthRateOnPremVMTitle']),
            ),
            value: String(cookieContent.annualGrowthRateOnPremVM),
          },
          {
            group: String(
              intl.formatMessage(
                messages['annualGrowthRateCloudInstanceTitle'],
              ),
            ),
            value: String(cookieContent.annualGrowthRateCloudInstance),
          },
          {
            group: String(intl.formatMessage(messages['estimatedRoi'])),
            value: String(cookieContent.estimate),
          },
        ])
      : null;
  }
  const buttonThanks: thanksTable[] = [
    {
      group: 'button1',
      value: String(intl.formatMessage(messages['returnToEstimator'])),
    },
  ];
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    setShowModal(true);
  }, [
    onPremVMs,
    cloudInstances,
    interestedInContainers,
    productToAcquire,
    estimatedPrice,
    cookieContent,
  ]);
  localStorage.setItem(
    'formContent',
    JSON.stringify({
      message: cookieContent,
      content: cookieContentObject,
    }),
  );
  return (
    <ThanksModal
      showThanksModal={showModal}
      pageTitle="Turbonomic Pricing Page"
      object="Turbonomic Pricing Page"
      productTitle={'Turbonomic Price estimator'}
      pageUrl={''}
      location={'Estimator'}
      titleThanks={titleThanks}
      widgetTitleThanks={widgetTitleThanks}
      contentThanks={contentThanks}
      {...(ROIShow && {
        contentThanks2: contentThanks2,
      })}
      buttonThanks={buttonThanks}
      setShowThanksModal={setShowThanksModal}
    ></ThanksModal>
  );
};

export default Thanks;
